<template>
  <div class="sidebar-wrap" :style="{ width: isOpen ? '240px' : '55px', }">
    <span @click="toggleHandler"
      :style="{ position: 'fixed', top: '60px', left: isOpen ? '224px' : '39px', transition: 'all 0.2s' }"
      class="material-icons icon-image-preview sidebar-icon" :class="{
        'menu-close': !isOpen,
      }">
      chevron_left
    </span>
    <SecondaryNavigationMenuItem v-for="(item, index) in menus.children" :key="index" :item="item" :level="level"
      dir="left" :isExtended="isOpen" :menu="menu" :asMenu="false" :additionalPaddingLeft="0" />
  </div>
</template>

<script>
import SecondaryNavigationMenuItem from './SecondaryNavigationMenuItem.vue'

export default {
  name: 'SecondaryNavigation',
  components: { SecondaryNavigationMenuItem },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    menu: { type: Array, default: () => [] }
  },
  emits: ['toggleMenu'],
  data () {
    return {
      level: 1
    }
  },
  computed: {
    menus () {
      return this.findTopParent(this.menu, this.$route.name)
    }
  },
  methods: {
    findTopParent (menu, targetName) {
      const results = []

      function helper (items, targetName, topParent = null) {
        for (const item of items) {
          if (item.route === targetName) {
            results.push(topParent || item)
          }
          if (item.children) {
            helper(item.children, targetName, topParent || item)
          }
        }
      }

      helper(menu, targetName)
      return results.find(r => r.name !== 'Shortcuts') || null
    },
    getIconPath (iconName) {
      try {
        return require(`@/assets/menu/${iconName}.svg`)
      } catch (error) {
        return null
      }
    },
    toggleHandler () {
      this.$emit('toggleMenu', !this.isOpen)
    }
  }
}
</script>

<style scoped lang="scss">

.menu-close {
  transform: matrix(-1, 0, 0, 1, 0, 0);
}

.sidebar-wrap {
  transition: all 0.2s;
  top: 52px;
  left: 0;
  height: -webkit-fill-available;
  position: fixed;
  background-color: $bgColorWhite;
  z-index: calc(#{$navigationMenuZIndex} - 1) !important;
  padding-top: 48px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 8px;
  padding-right: 8px;
}

.sidebar-icon {
 z-index: $navigationMenuZIndex !important;
  color: $body-color;
  background-color: $bgColorWhite;
  display: flex;
  width: 32px;
  height: 32px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  cursor: pointer;
}

.menu-item-name {
  animation: appears 0.2s 0.1s forwards;
  opacity: 0;
}

@keyframes appears {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
